import type { ArticleCardProps } from '@/lib/article-card';
import type { Category } from '@/lib/content-types';
import { breadcrumbJsonLd } from '@/lib/seo';
import { absoluteUrl, SITE_NAME, siteUrl } from '@/lib/site-url';

export function buildCategoryJsonLd(
    category: Category,
    articles: ArticleCardProps[] = [],
): Record<string, unknown>[] {
    const pageUrl = absoluteUrl(`/category/${encodeURIComponent(category.key)}`);
    const origin = siteUrl();
    const description =
        category.description
        || `כל החדשות והכתבות במדור ${category.name} באשקלון - ${SITE_NAME}`;

    const itemList = articles.slice(0, 20).map((article, index) => {
        const item: Record<string, unknown> = {
            '@type': 'ListItem',
            position: index + 1,
            url: absoluteUrl(`/article/${encodeURIComponent(article.slug)}`),
            name: article.title,
        };
        if (article.cover) item.image = article.cover;
        return item;
    });

    const collection: Record<string, unknown> = {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        '@id': `${pageUrl}#collection`,
        name: `${category.name} | ${SITE_NAME}`,
        description,
        url: pageUrl,
        inLanguage: 'he-IL',
        isPartOf: { '@id': `${origin}/#website` },
        about: {
            '@type': 'Thing',
            name: category.name,
        },
        publisher: { '@id': `${origin}/#organization` },
    };

    if (itemList.length > 0) {
        collection.mainEntity = {
            '@type': 'ItemList',
            name: `כתבות במדור ${category.name}`,
            numberOfItems: itemList.length,
            itemListOrder: 'https://schema.org/ItemListOrderDescending',
            itemListElement: itemList,
        };
    }

    return [
        collection,
        breadcrumbJsonLd([
            { name: 'ראשי', path: '/' },
            { name: category.name, path: `/category/${encodeURIComponent(category.key)}` },
        ]),
    ];
}
